import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

const Footer = () => (
  <footer className="bg-ink text-white" data-testid="site-footer">
    <div className="mx-auto max-w-[1500px] px-6 py-20 md:px-10 md:py-28">
      <div className="grid grid-cols-1 gap-14 md:grid-cols-12">
        <div className="md:col-span-5">
          <img
            src="/logo-black.webp"
            alt="SanCub"
            className="h-12 w-auto invert"
            data-testid="footer-logo"
          />
          <p className="mt-7 max-w-sm text-base leading-relaxed text-white/60">
            Tapware, baths and bathroom furniture designed for the way Australians live.
            Fresh, innovative and refined — for every home.
          </p>
          <Link
            to="/contact"
            data-testid="footer-enquire-link"
            className="group mt-8 inline-flex items-center gap-2 rounded-full bg-white px-6 py-3 text-[13px] font-semibold text-ink transition duration-300 hover:scale-[1.03] hover:bg-white/90"
          >
            Start an enquiry
            <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </Link>
        </div>

        <div className="md:col-span-2 md:col-start-8">
          <p className="text-[12px] font-semibold uppercase tracking-[0.18em] text-white/40">Explore</p>
          <ul className="mt-5 space-y-3 text-sm text-white/70">
            <li><Link data-testid="footer-link-collections" className="transition-colors duration-300 hover:text-white" to="/collections">Collections</Link></li>
            <li><Link data-testid="footer-link-about" className="transition-colors duration-300 hover:text-white" to="/about">About</Link></li>
            <li><Link data-testid="footer-link-blog" className="transition-colors duration-300 hover:text-white" to="/blog">Blog</Link></li>
            <li><Link data-testid="footer-link-stockists" className="transition-colors duration-300 hover:text-white" to="/stockists">Stockists</Link></li>
            <li><Link data-testid="footer-link-contact" className="transition-colors duration-300 hover:text-white" to="/contact">Contact</Link></li>
          </ul>
        </div>

        <div className="md:col-span-3 md:col-start-10">
          <p className="text-[12px] font-semibold uppercase tracking-[0.18em] text-white/40">Studio</p>
          <ul className="mt-5 space-y-3 text-sm text-white/70">
            <li>sales@sancub.com</li>
            <li>1300 680 580</li>
            <li>35 Apex Drive, Truganina VIC 3029</li>
            <li>Mon–Fri 9:00–5:30 · Sat–Sun 9:00–4:30 AEST</li>
          </ul>
        </div>
      </div>

      <div className="mt-16 flex flex-col gap-3 border-t border-white/10 pt-8 text-[12px] text-white/40 md:flex-row md:items-center md:justify-between">
        <span>© {new Date().getFullYear()} SanCub. All rights reserved.</span>
        <span>WHERE FORM MEETS FLOW</span>
      </div>
    </div>
  </footer>
);

export default Footer;
